import * as $ from "jquery";
import * as _ from "underscore";
import * as moment from "moment";

// Types
import Moment = moment.Moment;

// Models
import { TimePickerOptions } from "Content/ts/Models/Shared/DateTime/timePickerConfiguration";
import { DatePickerLibraryEvents } from "Content/ts/Models/Shared/DateTime/datePickerConfiguration";

// Services
import { DateTimeFormatterService } from "Content/ts/Shared/Controls/DateTime/Services/dateTimeFormatterService";

export module TimePickerServices {
    const LocalisedTimeFormat = DateTimeFormatterService.LocalisedMomentTimeFormat as string;

    // Purpose  :   Zebra doesn't have a standard configuration for 'steps'. However, the 'enabled_minutes' implementation is
    //              it's equivalent so this method takes the steps and sets selectable minutes.
    export function ConfigureEnabledMinutes(configuration: TimePickerOptions): false | Array<number> {
        if (configuration.MinutesStep == null || configuration.MinutesStep == undefined) {
            return false;
        }

        const startMinutesValue = 0 as number,
            maximumMinutesValue = 59 as number;

        return _.range(startMinutesValue, maximumMinutesValue, configuration.MinutesStep);
    };

    export function TimePickerOnLoad(element: HTMLElement, value: KnockoutComputed<Moment>): void {
        const dateTimePicker = $(element).data("Zebra_DatePicker") as DatePickerLibraryEvents;

        // Purpose  :   Will bind the value to the component text box at binding load if a value has been provided.
        if (value()) {
            let currentValue = value().format(LocalisedTimeFormat);

            if (!value().isValid()) {
                currentValue = moment().startOf("day").format(LocalisedTimeFormat);
            }

            dateTimePicker.set_date(currentValue);
        }
    };

    // Important:   Cannot be done via a standard subscribe due to the way Zebra works. When the datepicker is initialised the Knockout context
    //              is mostly destroyed so you lose some visibility on the HTML element. Due to this a couple of change events are bound to the
    //              object so these are detected without the user having to unfocus from the element when dealing with a form.
    export function ConfigureKeyPressEvents(element: HTMLElement, valueToUpdate: KnockoutComputed<Moment>): void {
        $(element)
            .on("blur", function () {
                UpdateTime(element, $(this).val(), valueToUpdate);
            })
            .on("keydown", function (event: JQueryEventObject) {
                // Important:   'keyCode' and 'which' have been deprecated across all browsers. Said codes didn't have a consistent implementation
                //              across all browsers so we've gone for this implementation as it seems to be more stable.
                // Sources  :   https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
                //              https://stackoverflow.com/questions/56771542/how-to-call-the-jquery-click-method-when-pressing-enter-on-the-keyboard
                if (event.key == "Enter") {
                    UpdateTime(element, $(this).val(), valueToUpdate);
                }
            });

        // Add to the icon button so times will update
        $(element).next().on("blur", () => {
            UpdateTime(element, $(element).val(), valueToUpdate);
        });

        $(element);
    };

    function UpdateTime(element: HTMLElement, value: any, valueToUpdate: KnockoutComputed<Moment>): void {
        const dateTimePicker = $(element).data("Zebra_DatePicker") as DatePickerLibraryEvents;

        let time = moment(value, LocalisedTimeFormat);
        valueToUpdate(time);

        if (time) {
            dateTimePicker.set_date(time.format(LocalisedTimeFormat));
        } else {
            dateTimePicker.clear_date();
        }
    };
}